<template>
  <!-- 贸易结算水表(终端用户远传表) -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="12">
            <a-form-item label="设备名称">
              <a-input v-model="query.deviceName" placeholder="请输入设备名称" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="负责人">
              <a-input v-model="query.principal" placeholder="请输入负责人" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="12">
            <a-form-item label="开始时间">
              <a-range-picker v-model="Uploadtime" @change="onChanget" />
            </a-form-item>
          </a-col>
          <!-- <a-col :md="6" :sm="12">
            <a-form-item label="开始时间">
              <a-date-picker
                v-model="query.startTime"
                format="YYYY-MM-DD"
                valueFormat="YYYY-MM-DD"
                placeholder="请选择开始时间"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="结束时间">
              <a-date-picker
                v-model="query.endTime"
                format="YYYY-MM-DD"
                valueFormat="YYYY-MM-DD"
                placeholder="请选择结束时间"
              />
            </a-form-item>
          </a-col> -->
        </a-row>
        <a-row>
          <a-col :md="6" :sm="12">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="PatrolAdd()" v-action:add>新增</a-button>
              <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()" v-action:del>删除</a-button>
              <!-- <a-button
                type="primary"
                style="margin-left: 8px"
                @click="exportHandle()"
                v-action:export
              >导出</a-button>-->
            </span>
          </a-col>
        </a-row>
        <!-- <a-row :gutter="48">

        </a-row>-->
      </a-form>
    </div>
    <a-table
      rowKey="id"
      bordered
      :scroll="{ x: 2100 }"
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
    >
      <span slot="action" slot-scope="text, record">
        <!-- <a @click="editHandle(record)" v-action:edit>编辑</a> -->
        <!-- <a-divider type="vertical" /> -->
        <a @click="goDetails(record)">详情</a>
      </span>
      <span slot="planTime" slot-scope="text" v-if="text !== null">{{ text }} 天</span>
      <span slot="lastMaintenanceDate" slot-scope="text" v-if="text !== null">{{
        moment(text).format('YYYY-MM-DD')
      }}</span>
      <span slot="nextMaintenanceDate" slot-scope="text" v-if="text !== null">{{
        moment(text).format('YYYY-MM-DD')
      }}</span>
      <!-- <span slot="createTime" slot-scope="text">{{ moment(text).format('YYYY-MM-DD') }}</span>
      <span slot="lastMaintenanceDate" slot-scope="text">{{ moment(text).format('YYYY-MM-DD') }}</span>
      <span slot="nextMaintenanceDate" slot-scope="text">{{ moment(text).format('YYYY-MM-DD') }}</span> -->
    </a-table>

    <equipment-modal ref="EquipmentModal" @handleOk="queryList"></equipment-modal>
    <a-modal title="详情" :visible="showTubeV" :width="800" destroyOnClose @cancel="closeTubeView">
      <!-- style="position: absolute; left: 18rem; z-index: 999; top: 3rem" -->
      <template slot="footer">
        <a-button @click="closeTubeView">取消</a-button>
      </template>
      <a-row style="margin-top: 20px">
        <a-col :span="12">设备名称：{{ Details.deviceName }}</a-col>
        <a-col :span="12">设备编码：{{ Details.deviceNo }}</a-col>
      </a-row>
      <a-row style="margin-top: 20px">
        <a-col :span="12">片区：{{ Details.zoneName }}</a-col>
        <a-col :span="12">负责人：{{ Details.principalName }}</a-col>
      </a-row>
      <a-row style="margin-top: 20px">
        <a-col :span="12">协办人：{{ Details.maintenanceStaffName }}</a-col>
        <a-col :span="12">养护周期：{{ Details.maintenanceFrequency }}</a-col>
      </a-row>
      <a-row style="margin-top: 20px">
        <a-col :span="12"
          >上次养护日期：<span v-if="Details.lastMaintenanceDate !== null">{{
            moment(Details.lastMaintenanceDate).format('YYYY-MM-DD')
          }}</span></a-col
        >
        <a-col :span="12"
          >下次养护日期：<span v-if="Details.nextMaintenanceDate !== null">{{
            moment(Details.nextMaintenanceDate).format('YYYY-MM-DD')
          }}</span></a-col
        >
      </a-row>
      <a-row style="margin-top: 20px">
        <a-col :span="12">计划处理时长： {{ Details.planTime }} 天</a-col>
        <a-col :span="12" @click="addAddress"
          >设备位置：<span style="color: #262daa">{{ Details.deviceLocation }}</span></a-col
        >
      </a-row>
    </a-modal>
    <a-modal
      title="地图"
      style="top: 20px"
      :width="800"
      v-model="mapVisible"
      @ok="mapVisible = false"
      @cancel="mapVisible = false"
    >
      <lonlat-map ref="lonlatMaps" @handleMapOk="handleMapOk"></lonlat-map>
    </a-modal>
  </a-card>
</template>

<script>
import moment from 'moment'
import mixinViewModule from '@/mixin/commonModel'
import { PERMISSION_ENUM } from '@/core/permission/permission'
import EquipmentModal from './modules/EquipmentModal'
// import LonlatMap from '../../../maintenance/Equipment/lonlatMap.vue'
import LonlatMap from '../EventManagement/modules/lonlatMap.vue'
const columns = [
  {
    title: '序号',
    dataIndex: '',
    key: 'rowIndex',
    width: 70,
    align: 'center',
    customRender: function (t, r, index) {
      return parseInt(index) + 1
    },
  },
  {
    title: '设备名称',
    dataIndex: 'deviceName',
  },
  {
    title: '设备编码',
    dataIndex: 'deviceNo',
  },
  {
    title: '片区',
    dataIndex: 'zoneName',
  },
  {
    title: '负责人',
    dataIndex: 'principalName',
  },
  {
    title: '协办人',
    dataIndex: 'maintenanceStaffName',
  },
  {
    title: '养护周期',
    dataIndex: 'maintenanceFrequency',
  },
  {
    title: '计划处理时长',
    dataIndex: 'planTime',
    scopedSlots: { customRender: 'planTime' },
  },

  {
    title: '上次养护日期',
    dataIndex: 'lastMaintenanceDate',
    scopedSlots: { customRender: 'lastMaintenanceDate' },
  },
  {
    title: '下次养护日期',
    dataIndex: 'nextMaintenanceDate',
    scopedSlots: { customRender: 'nextMaintenanceDate' },
  },
  {
    title: '设备位置',
    dataIndex: 'deviceLocation',
  },
  {
    title: '操作',
    dataIndex: 'action',
    align: 'center',
    fixed: 'right',
    width: 120,
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  mixins: [mixinViewModule],
  components: {
    EquipmentModal,
    LonlatMap,
  },
  name: 'Equipment',
  data() {
    return {
      currentId: '',
      queryUrl: '/pipe-network/device_maintenances/page',
      deleteUrl: '/pipe-network/device_maintenances',
      addOrUpdateUrl: '/pipe-network/device_maintenances',
      queryOneUrl: '/pipe-network/device_maintenances',
      //   exportDataUrl: 'pipe-network/tenant_events/export',
      //   exportFileName: '事件管理表.xlsx',
      showTubeV: false,
      mapVisible: false,
      Details: {},
      query: {
        workOrderType: '',
        deviceName: '',
        deviceNo: '',
        maintainPerson: '',
        sysType: '巡检',
        startTime: '',
        endTime: '',
        deviceName: '',
      },
      Uploadtime: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      columns,
      addOrUpdateForm: {
        eventName: '',
        eventType: '',
        address: '',
        reportPerson: '',
        phone: '',
        reportTime: '',
        eventDescription: '',
        accessorys: [],
      },
    }
  },
  filters: {},
  computed: {
    rules() {
      return {}
    },
  },
  created() {},
  methods: {
    handleMapOk() {},
    addAddress() {
      this.mapVisible = true
      if (this.Details.place) {
        var pointData = this.Details.place.split(',')
        var newPointData = pointData.map((item) => {
          return (item = parseFloat(item))
        })
        console.log(newPointData, this.$refs) // [113.678351, 25.538859]
        this.$nextTick(() => {
          this.$refs.lonlatMaps.changepoint(newPointData)
        })
      } else {
        this.$nextTick(() => {
          this.$refs.lonlatMaps.changepoint([0, 0])
        })
      }
    },
    resetList() {
      this.query = {
        workOrderType: '',
        deviceName: '',
        deviceNo: '',
        maintainPerson: '',
        sysType: '巡检',
        startTime: '',
        endTime: '',
        deviceName: '',
      }
      this.pagination.current = 1
      this.Uploadtime = []
      this.selectedRows = []
      this.queryList()
    },
    queryList() {
      const params = {
        orderColumn: this.orderColumn,
        orderType: this.orderType,
        ...this.query,
      }
      if (this.needPage) {
        params.page = 1
        this.pagination.current = 1
        params.limit = this.pagination.pageSize
      }
      this.dataListLoading = true
      this.$http
        .get(this.queryUrl, {
          params,
        })
        .then(({ data }) => {
          this.dataListLoading = false
          if (this.needPage) {
            this.list = data.list || []
            this.selectedRows = []
            this.pagination.total = data.total ? parseInt(data.total) : 0

            if (data.total > 0) {
              this.isadd = false
            } else {
              this.isadd = true
            }
          } else {
            this.list = data
          }
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    onChanget(value, dateString) {
      this.query.startTime = dateString[0]
      this.query.endTime = dateString[1]

      console.log(this.query.startTime, '开始', this.query.endTime, '结束')
    },
    moment,
    closeTubeView() {
      this.showTubeV = false
    },
    goDetails(record) {
      console.log(record)
      this.Details = record
      this.showTubeV = true
    },
    EndOnChange(date, dateString) {
      this.query.endTime = dateString
    },
    StartOnChange(date, dateString) {
      this.query.startTime = dateString
    },
    PatrolAdd() {
      this.$refs.EquipmentModal.edit()
    },
    editHandle(record) {
      this.$refs.EquipmentModal.edit(record.id)
    },
  },
  watch: {},
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
/deep/ .ant-form-item {
  margin-bottom: 12px;
}
/deep/.ant-table-thead > tr > th > {
  text-align: center;
}

/deep/.ant-table-tbody > tr > td {
  text-align: center;
}
</style>
